import { FC, forwardRef, ReactNode } from 'react'

import ErrorProvider from '../errorHandler/ErrorProvider'
import { setStorage } from '../storage/setStorage'

interface Props {
  disabled?: boolean
}

export const shareSessionStorage = <P extends Props>(WrappedComponent: FC<P> | { props: P }) => {
  const Wrapped = WrappedComponent as FC<P>
  // any used because of https://github.com/DefinitelyTyped/DefinitelyTyped/issues/35834
  const Component = forwardRef<any, P & { children?: ReactNode }>(function Component(props, ref) {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const case_id = urlParams.get('case_id')
    const token = urlParams.get('token')

    if (token) {
      setStorage(sessionStorage, 'token', token).catch((err) => {
        ErrorProvider.showError(err)
      })
    }

    if (case_id) {
      setStorage(sessionStorage, 'case_id', case_id).catch((err) => {
        ErrorProvider.showError(err)
      })
    }

    return <Wrapped {...props} ref={ref} />
  })

  return Component
}
